<template>
  <div class="customer-search-page">
    <h2>Customer Search</h2>
    <hr>
    <div class="subheader-wrapper">
      <h4>Customers</h4>
      <div class="icon-group">
        <i class="fa fa-plus" @click="addNewPrivateCustomer" aria-hidden="true"></i>
      </div>   
    </div>  
    <hr>
    <BasicDataGrid 
      :dataSource="customers" 
      :dataGridKey="dataGridKey"
      gridRef="customerSearchGrid"
      :columns="columns" 
      :showColumnLines="true"
      :actions="actions"
      @editCustomer="editCustomer" 
      :allowExport="false"
      :multiSelect="false"
      @checkout="checkout"/>
    <Modal ref="editPrivateCustomerModal">
      <PrivateCustomerForm v-model="customer" 
        @privateCustomerSaved="privateCustomerSaved" 
        @cancelPrivateCustomer="cancelPrivateCustomer" 
        :editingCustomer="editingCustomer"/>
    </Modal>
  </div>
</template>
<script>
import BasicDataGrid        from '../../../components/BasicDataGrid.vue';
import PrivateCustomerForm  from '../../../components/PrivateCustomerForm.vue';

import { CustomerService }      from '@/services';

import { deepCopyObject }    from "../../../modules/helpers.js";
// let customers = getDataSource('CurrentUser/Customers')
export default {
  name: 'CustomerSearch',
  components: {
    BasicDataGrid,
    PrivateCustomerForm
  },
  data() {
    return {
      dataGridKey: 'Id',
      newCustomer: {
        Id: 0,
        JdeNum: '',
        Name: '',
        LicenseNumber: null,
        Specialty: null,
        PhoneNum: '',
        FaxNum: '',
        CustomerContact: {
          FirstName: '',
          LastName: '',
          PhoneNumber: '',
          Email: null,
        },
        Address: {
          AddressId: 0,
          Name: '',
          Line1: '',
          Line2: '',
          City: '',
          StateId: null,
          ZipCode: '',
          LocationCode: '',
        },
        IsPrivate: true
      },
      customer: {},
      loading: false,
      editingCustomer: true, 
      actions: [
        {
          hint: 'Edit',
          icon: 'edit',
          emit: 'editCustomer',
        },
        {
          hint: 'Checkout',
          icon: 'file',
          emit: 'checkout'
        }],
      
      customers: [],
      columns: [
        {text: 'ID', value: 'Id', dataType: "number"}, 
        {text: 'JDE #', value:'JdeNum', dataType: "string"}, 
        {text: 'Name', value:'Name', dataType: "string"},  
        {text: 'License #', value:'LicenseNumber', dataType: "string"},  
        {text: 'Specialty', value:'Specialty', dataType: "string"},  
        {text: 'Address', value:'Address.Line1', dataType: "string"},
        {text: 'City', value:'Address.City', dataType: "string"}, 
        {text: 'State', value:'Address.StateProvince', dataType: "string"}, 
        {text: 'Zip', value:'Address.ZipCode', dataType: "string"},
        {text: 'Phone', value:'CustomerContact.PhoneNumber', dataType: "string"},
        {text: 'Contact', value:'CustomerContactName', dataType: "string"},
        {text: 'Groups', value: 'GroupNames', dataType: 'string'},
        {text: 'Status', value:'Status', dataType: "string"},
      ],
    };
  },
  methods: {
    addNewPrivateCustomer(){
      this.editingCustomer = false;
      this.customer = deepCopyObject(this.newCustomer);
      this.toggleEditPrivateCustomerModal()
    },
    toggleEditPrivateCustomerModal(){
      this.$refs.editPrivateCustomerModal.toggle()
    },
    checkout(event){
      this.$router.push({ name: "CustomerOrder", params:{'cid' : event.row.data.Id}})
    },
    privateCustomerSaved(){
      this.customers = CustomerService.getDataSource(this.dataGridKey);
      this.toggleEditPrivateCustomerModal()
    },
    cancelPrivateCustomer(){
      
      this.toggleEditPrivateCustomerModal()
    },
    editCustomer(event){
      this.editingCustomer = true;
      this.customer = event.row.data
      
      this.toggleEditPrivateCustomerModal()
    },
    getCustomers(){
      this.customers = CustomerService.getDataSource(this.dataGridKey);
    }
  },
  created(){
    this.getCustomers();
  }
};
</script>
<style lang="scss" scoped>
  .customer-search-page {
    // max-width: 1800px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      margin: 5px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
</style>
